import React from "react";
import { SkeletonStyle } from "./Skeleton.style";

export default function Skeleton({ height, width, marginBottom }) {
	return (
        <SkeletonStyle
          style={{
            height: `${height || 10}px`,
            width: `${width || 100}%`,
            marginBottom: `${marginBottom || 0}px`,
          }}
        />
      );
}
    